import { formatText } from "../pushNotificationMessage";

const messages = async ({ actionType, notifyContent }) => {

    const message = {
        newEnquiry: {
            title: `Nueva consulta`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `Rechazada`,
            message: `${formatText(notifyContent['userName'])}: Reserva rechazada`
        },
        approved: {
            title: `Aprobada`,
            message: `${formatText(notifyContent['userName'])}: Reserva aprobada`
        },
        newMessage: {
            title: `Nuevo mensaje`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `La reserva está cancelada`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        newBooking: {
            title: `Nueva reserva`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `Nueva reserva`,
            message: `${formatText(notifyContent['userName'])}: Su solicitud está preaprobada`
        },
        listApproved: {
            title: `El administrador ha verificado su anuncio`,
            message: `${formatText(notifyContent['userName'])} : El administrador ha verificado su anuncio ${notifyContent['listTitle']} . Por favor publique su anuncio para obtener reservas.`
        },
        listDeclined: {
            title: `El administrador ha rechazado su anuncio`,
            message: `${formatText(notifyContent['userName'])} : El administrador ha rechazado su solicitud de inclusión en el listado ${notifyContent['listTitle']} por la razón de ${notifyContent['reason']}. Por favor actualice la información del listado y envíela para su aprobación.`
        },
        noHostPayout: {
            title: `Faltan detalles de pago`,
            message: `${formatText(notifyContent['userName'])}¡Actualización! Actualiza tu información de pago para recibir los pagos de tu reserva.`
        },
        approvedDocument: {
            title: `Documento aprobado`,
            message: `Su documento ha sido aprobado exitosamente.`
        },
        rejectDocument: {
            title: `¡Documento rechazado!`,
            message: `El administrador ha rechazado su documento enviado. Para más información, póngase en contacto con él.`
        }
    }

    return message[actionType]
}
export default messages;